import { Shield } from 'lucide-react';
import { FadeInUp } from '../components/animations';
import SEO from '../components/SEO';
import PolicySection from '../components/PolicySection';
import privacyPolicyData from '../data/privacyPolicyData';

const PrivacyPage = () => (
  <div className="pt-20 min-h-screen bg-[#fafaf9]" data-testid="privacy-page">
    <SEO title="Privacy Policy | Taiga Sourcing" description="Privacy policy for Taiga Sourcing — how we handle your data." path="/privacy" />
    <section className="py-32 bg-gradient-to-br from-[#0B2A57] to-[#4A5F78] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <FadeInUp>
          <Shield size={48} className="mx-auto mb-4" />
          <h1
            className="text-5xl sm:text-6xl font-bold tracking-tight leading-none mb-6"
            style={{ fontFamily: 'Cabinet Grotesk' }}
          >
            Privacy Policy
          </h1>
          <p className="text-lg text-white/90 leading-relaxed max-w-3xl mx-auto">
            Your privacy is important to us
          </p>
        </FadeInUp>
      </div>
    </section>

    <section className="py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <FadeInUp>
          <div className="prose prose-lg max-w-none">
            <p className="text-[#1F2937] mb-8 text-lg">
              <strong>Effective Date:</strong> January 1, 2026<br />
              This Privacy Policy explains how Taiga Sourcing collects, uses, and protects your personal information.
            </p>

            {privacyPolicyData.map((section) => (
              <PolicySection key={section.title} title={section.title}>
                {section.content}
              </PolicySection>
            ))}
          </div>
        </FadeInUp>
      </div>
    </section>
  </div>
);

export default PrivacyPage;
